import React from "react";
import { Menu, Image } from "semantic-ui-react";
import "../styles/SettingsNavbar.css";

const SettingsNavbar = ({ setToggle, isAuthenticated }) => {
  return (
    <Menu fixed="top" className="navbar" borderless>
      <Menu.Menu>
        <div className="menu-item-left">
          {isAuthenticated && (
            <div onClick={setToggle} className="mobile-sidebar-icon">
              <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
            </div>
          )}
        </div>
      </Menu.Menu>
    </Menu>
  );
};

export default SettingsNavbar;
